
const isInBrowser = () => typeof window !== 'undefined';

const isInNodeJS = () => typeof global !== 'undefined';

const isInWebWorker = () => !isInBrowser && typeof self !== 'undefined';

const isInJestEnv = () => isInNodeJS() && typeof global.describe === 'function';

const getGlobalObject = () => {
  if (isInBrowser()) {
    return window;
  }
  if (isInNodeJS()) {
    return global;
  }
  if (isInWebWorker()) {
    return self;
  }
  if (isInJestEnv()) {
    return {};
  }
  return {};
};

const globalObject = getGlobalObject();

export default globalObject;
